import axios from '@/plugins/axios'

export function getRidingCardOrder(params = {}) {
  return axios.get('card_riding_order', { params })
}
